<canvas #downtimeChart></canvas>
